import React, { useEffect, useState } from "react";
import { useGetFaqListMutation, useUpdFaqActiveStatusMutation } from "../../../../../store/admin/adminFaqApiSlice";
import { useNavigate } from "react-router-dom";
interface ParamType {page : any, size : number, keyword : string, sortOrder : string, sortColumn : string}
export interface Props {data:any, getList : Function}
export const ListFaq:React.FC<Props> = ({data, getList}) => {
    const navigate = useNavigate()
    const [updFaqActiveStatusApi] = useUpdFaqActiveStatusMutation()
    const handleChangeActiveStatus = async(idx:any, status : string) => {
        const formData : any = new FormData()
        formData.append('faq_idx', idx)
        formData.append('faq_active_status', status === 'Y'?'N':'Y')
        const result : any = await updFaqActiveStatusApi(formData)
        if(result.data.result === true){getList()}
    }
    return(
        <>
         <tbody>
            {data?.map((list:any)=>(
                <tr className="active" key={list?.faq_idx}>
                    <td onClick={()=>navigate(`/dotsAdmin/customerCenter/faq/${list?.faq_idx}`)}>
                        <span>{list?.faq_question_kr===''?list?.faq_question_en:list?.faq_question_kr}</span>
                    </td>
                    <td>
                        <span className="toggleSwitch">
                            <input type="checkbox" id={list?.faq_idx} checked={list?.faq_active_status === 'Y'?true:false} onChange={()=>handleChangeActiveStatus(list?.faq_idx, list?.faq_active_status)} className="toggleIpt" hidden/> 
                            <label htmlFor={list?.faq_idx} className="toggleSwitch">
                                <span className="toggleButton"></span>
                            </label>
                        </span>
                    </td>
                </tr>
            ))}
        </tbody>
        </>
    )
}